/**
 * Rich text without its tags, for the tab title.
 *
 * @function stripTags
 * @since 1.0.0
 */
function stripTags(value) {
    return (value !== null && value !== void 0 ? value : '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}
/**
 * Store headline (DIRECT_SALES_FORM_HEADLINE) in the language, or ''.
 *
 * @function readStoreHeadline
 * @since 1.0.0
 */
export function readStoreHeadline(configurationFields, language) {
    var _a, _b, _c, _d;
    const value = (_a = configurationFields === null || configurationFields === void 0 ? void 0 : configurationFields.find((conf) => conf.fieldKey === 'DIRECT_SALES_FORM_HEADLINE')) === null || _a === void 0 ? void 0 : _a.value;
    try {
        return (_d = (_c = (_b = JSON.parse(value)) === null || _b === void 0 ? void 0 : _b.translations) === null || _c === void 0 ? void 0 : _c[language]) !== null && _d !== void 0 ? _d : '';
    }
    catch (_e) {
        return '';
    }
}
/**
 * Tab title of a store page, in the format of the server-rendered title:
 * `Product | Business` on a product or category page, otherwise
 * `Business | Headline`. Google reads the title after rendering.
 *
 * @function storeDocumentTitle
 * @since 1.0.0
 */
export function storeDocumentTitle(input) {
    const pageTitle = stripTags(input.pageTitle);
    if (pageTitle) {
        return `${pageTitle} | ${input.businessName}`;
    }
    const headline = stripTags(input.headline);
    return headline ? `${input.businessName} | ${headline}` : input.businessName;
}
